//.........global dev.........
// const baseUrl_admin = 'https://dev.app.marx.lk/admin_global';
// const baseUrl_public = 'https://dev.app.marx.lk/global';
// const returnMarxUrl = 'https://dev.global.marxpay.com';
const baseUrl_admin = 'https://app.global.marx.lk/admin';
const baseUrl_public = 'https://app.global.marx.lk/api';
const returnMarxUrl = 'https://global.marxpay.com';



export {baseUrl_admin,baseUrl_public,returnMarxUrl};


// note : effect of merchant type
